import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import auth from './auth';
import slots from './modules/slots';
import timezone from './modules/timezone';
import notification from './modules/notification';

Vue.use(Vuex);

const timezoneState = createPersistedState({
  paths: ['timezone'],
});

export default new Vuex.Store({
  state: {
    showSideMenu: true,
  },
  mutations: {
    TOGGLE_MENU(state) {
      state.showSideMenu = !state.showSideMenu;
    },
  },
  actions: {
    toggleMenu({ commit }) {
      commit('TOGGLE_MENU');
    },
  },
  modules: {
    auth,
    slots,
    timezone,
    notification,
  },
  plugins: [timezoneState],
});
